namespace $.$$ {
	
	$mol_style_define( $giper_baza_app_stat_page, {
		
		flex: {
			basis: `100%`,
			grow: 1,
		},
		
		Main: {
			flex: {
				grow: 1,
			},
		},
		
		Charts: {
			align: {
				self: 'stretch',
			},
		},
		
		$mol_chart: {
			height: `20rem`,
			flex: {
				basis: `25rem`,
				shrink: 0,
			},
		},
		
	} )
	
}
